import SwitchVertical01 from "@untitled-ui/icons-react/build/esm/SwitchVertical01";
import { useCallback, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useDispatch, useSelector } from "react-redux";
import {
  SEARCH_TYPES,
  doSearch,
  setSearchType,
  setSortBy,
} from "../../../../../store/reducer/_searchReducer";
import {
  getQueryValue,
  getSearchResults,
  getSearchResultsType,
  getSearchType,
} from "../../../../../store/selectors";
import { PDLButton, PDLTypography } from "../../../dna";
import { Pagination } from "../../../global";
import FilterCarouselContent from "../../../global/_filterCarouselContent";
import ResultItem from "../_resultItem";
import "./index.scss";

const BlocoResultados = ({ tipo = null }) => {
  const dispatch = useDispatch();

  const query = useSelector(getQueryValue);
  const searchType = useSelector(getSearchType);
  const searchResults = useSelector(getSearchResults);
  const searchResultsType = useSelector(getSearchResultsType);
  const sortBy = useSelector((state) => state.searchContext.sortBy);

  const all = searchResultsType?.toLowerCase() === "all";
  const {
    total = 0,
    results = [],
    currentPage = 1,
    totalPages = 0,
  } = (tipo && searchResults[tipo]) || {};
  const { title } = (tipo && SEARCH_TYPES[tipo]) || {};

  const currentSearchType = searchType.id;

  const handleShowMoreTypes = useCallback(() => {
    dispatch(setSearchType(tipo));
    dispatch(
      doSearch({
        query,
        searchType: tipo && SEARCH_TYPES[tipo],
        page: 1,
      }),
    );
  }, [dispatch, query, tipo]);

  const handleSort = (sort) => {
    dispatch(setSortBy(sort));
    dispatch(
      doSearch({
        query,
        searchType: SEARCH_TYPES[tipo],
        page: 1,
        sortBy: sort,
      }),
    );
  };

  const handlePageChange = (newPage) => {
    const searchTypeObj = SEARCH_TYPES[tipo] || searchType;

    document
      .querySelector(".pdl_component_header")
      ?.scrollIntoView({ behavior: "instant" });

    dispatch(
      doSearch({
        query,
        searchType: searchTypeObj,
        page: newPage,
        sortBy,
      }),
    );
  };

  useEffect(() => {
    const lastId = sessionStorage.getItem("last-clicked-result-item");
    if (!lastId) return;

    const el = document.getElementById(`result-item-${lastId}`);

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    sessionStorage.removeItem("last-clicked-result-item");
  }, []);

  const renderResults = useCallback(
    () =>
      results.map((item, index) => (
        <ResultItem
          key={index}
          item={item}
          tipo={tipo}
          index={index}
          searchTerm={query}
        />
      )),
    [results, tipo, query],
  );

  return (
    <div key={tipo} className="pdl_components_lista_resultados_bloco">
      <div>
        <PDLTypography size="md" className="mb-3 total-elements-description">
          {title} {!!query && "sobre "}
          <PDLTypography
            as="span"
            size="md"
            weight="bold"
            className="total-elements-description"
          >
            {query}
          </PDLTypography>
        </PDLTypography>
      </div>

      <header className="d-flex flex-row align-items-center justify-content-between filter-header">
        <PDLTypography size="sm" className="min-w-fit">
          {total >= 500 ? "Mais de 1.000" : total} resultados
          {!all && totalPages > 1 && (
            <span className="ms-2">
              {" "}
              {"( "} Página {currentPage} {" )"}
            </span>
          )}
        </PDLTypography>

        <FilterCarouselContent tipo={tipo || ""} />

        {!all && currentSearchType !== "modelos" && (
          <DropdownButton
            variant="outline-secondary"
            title={
              <>
                <SwitchVertical01 className="me-2" />
                {sortBy === "data" ? "Mais Recente" : "Relevância"}
              </>
            }
            id="dropdown-sort-options"
          >
            <Dropdown.Item onClick={() => handleSort("relevancia")}>
              Relevância
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleSort("data")}>
              Mais Recente
            </Dropdown.Item>
          </DropdownButton>
        )}
      </header>

      <div className="results-container">{renderResults()}</div>
      {all && total > 2 && (
        <div className="show-more-button">
          <PDLButton
            variant="secondary"
            size="sm"
            className="gray ms-3"
            onClick={handleShowMoreTypes}
          >
            Mostrar mais {title}
          </PDLButton>
        </div>
      )}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        showFirstLast={false}
        showPrevNext={true}
        maxVisiblePages={5}
        size="md"
        all={all}
      />
    </div>
  );
};

export default BlocoResultados;
